(function()
{
	var Button = include('springroll.pixi.Button');
	var Container = include('PIXI.Container');
	var Debug = include('springroll.Debug', false);
	var Ease = include('createjs.Ease');
	var Graphics = include('PIXI.Graphics');
	var Sprite = include('PIXI.Sprite');
	var Texture = include('PIXI.Texture');
	var Tween = include('createjs.Tween');
	var ButtonSounds = include('springroll.ButtonSounds');


	/**
	 * The pause menu display
	 * @class PauseMenu
	 * @extends {PIXI.Container}
	 */
	var PauseMenu = function(config, scalingSize)
	{
		Container.call(this);

		/**
		 * The pause menu configuration
		 * @property {Object} config
		 */
		this.config = config;

		this.onRestart = this.onRestart.bind(this);
		this.onPlay = this.onPlay.bind(this);

		/**
		 * The graphic tint behind pause screen
		 * @property {PIXI.Graphics} blocker
		 */
		var blocker = this.blocker = new Graphics();
		blocker.beginFill(0x000000, config.blocker.alpha);
		blocker.lineStyle(0, 0x000000, 0);
		blocker.drawRect(0, 0, scalingSize.maxWidth, scalingSize.height);
		blocker.endFill();
		blocker.x = -(scalingSize.maxWidth - scalingSize.width) / 2;

		/**
		 * The background display graphics
		 * @property {PIXI.Sprite} background
		 */
		this.background = new Sprite(Texture.fromImage(config.background.art));

		/**
		 * The resume button
		 * @property {springroll.pixi.Button} playButton
		 */
		this.playButton = new Button(config.playButton.art);
		this.playButton.on('buttonPress', this.onPlay);

		/**
		 * The restart the gameplay button
		 * @property {springroll.pixi.Button} restartButton
		 */
		this.restartButton = new Button(config.restartButton.art);
		this.restartButton.on('buttonPress', this.onRestart);

		this.buttonSounds = new ButtonSounds('ButtonSelect', 'ButtonRollover', [this.playButton, this.restartButton]);

		//Set the positions
		setPosition(this.background, config.background);
		setPosition(this.playButton, config.playButton);
		setPosition(this.restartButton, config.restartButton);

		//Add the display
		this.addChild(blocker);
		this.addChild(this.background);
		this.addChild(this.playButton);
		this.addChild(this.restartButton);

		//Default hide
		this.visible = false;
	};

	//Set the position of a display object from data
	var setPosition = function(obj, data)
	{
		obj.x = data.x || 0;
		obj.y = data.y || 0;
	};

	var s = Container.prototype;
	var p = extend(PauseMenu, Container);

	p.onRestart = function()
	{
		this.emit('restart');
	};

	p.onPlay = function()
	{
		this.emit('resume');
	};

	p.removeTweens = function()
	{
		Tween.removeTweens(this.blocker);
		Tween.removeTweens(this.background);
	};

	/**
	 * Show the panel
	 * @method show
	 */
	p.show = function()
	{
		this.removeTweens();

		this.playButton.visible =
			this.restartButton.visible = false;

		var config = this.config.background;
		this.visible = true;

		//fade in the blocker
		this.blocker.alpha = 0;
		Tween.get(this.blocker)
			.to(
				{
					alpha: 1
				},
				config.inTime,
				Ease[config.inEase]
			);

		//Drop the sign
		this.background.y = -this.background.height;
		Tween.get(this.background)
			.to(
				{
					y: 0
				},
				config.inTime,
				Ease[config.inEase]
			)
			.call(transitionInDone.bind(this));
	};

	/**
	 * Transition in is done
	 * @method transitionInDone
	 * @private
	 */
	var transitionInDone = function()
	{
		this.playButton.visible =
			this.restartButton.visible = true;
		this.emit('enter');
	};

	/**
	 * Hide the panel
	 * @method hide
	 */
	p.hide = function()
	{
		this.removeTweens();

		this.playButton.visible =
			this.restartButton.visible = false;

		var config = this.config.background;

		//fade in the blocker
		Tween.get(this.blocker)
			.to(
				{
					alpha: 0
				},
				config.outTime,
				Ease[config.outEase]
			);

		//Drop the sign
		Tween.get(this.background)
			.to(
				{
					y: -this.background.height
				},
				config.outTime,
				Ease[config.outEase]
			)
			.call(transitionOutDone.bind(this));
	};

	/**
	 * Transition in is done
	 * @method transitionOutDone
	 * @private
	 */
	var transitionOutDone = function()
	{
		this.visible = false;
		this.emit('exit');
	};

	/**
	 * destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		this.restartButton.off('buttonPress', this.onRestart);
		this.playButton.off('buttonPress', this.onPlay);

		this.removeTweens();

		s.destroy.call(this, true);

		this.config = null;
		this.background = null;
		this.playButton = null;
		this.restartButton = null;
		this.blocker = null;
		this.onRestart = null;
		this.onPlay = null;

		this.buttonSounds.destroy();
	};

	namespace('nature').PauseMenu = PauseMenu;

}());
